module.exports = __webpack_public_path__ + "77f482ab157d52659259bb22c37cc770.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/sectors_bg@3x.jpg
// module id = 666
// module chunks = 0